import ContactsPage from "../components/Contacts";

export default function Contacts() {
  return <ContactsPage />;
}
